// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ReferralProviderResponse } from './referral-provider-response';

/** See com.rev360.pms.api.controller.patient.referral.ReferralSearchResponse */
/* istanbul ignore next */
@GandalfModel
export class ReferralSearchResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	active!: boolean;

	@GandalfProperty({ designType: Date })
	appointmentDate!: Date | null;

	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	referralDate!: Date;

	@GandalfProperty({ designType: Number })
	referralId!: number;

	@GandalfProperty({ designType: ReferralProviderResponse })
	referredBy!: ReferralProviderResponse | null;

	@GandalfProperty({ designType: ReferralProviderResponse })
	referredTo!: ReferralProviderResponse | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	responseDate!: Date | null;

}
